import { useRouter } from "next/router";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { portalRoutes } from "@nju/routes";
import { BlockContent, GeneralErrorNotification, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function NoPesel() {
  const router = useRouter();

  return (
    <LayoutWrapper>
      <Header />
      <ClientSideOnly>
        <BlockContent grid="default" spacing="xl" tone="none">
          <GeneralErrorNotification
            callback={() => {
              router.replace(portalRoutes.mojeKonto.index.get());
            }}
            copy="zobacz ofertę nju subskrypcja"
            description="Nie masz numeru PESEL, więc nie możesz skorzystać z tej oferty. Wybierz nju subskrypcję."
            icon="times-circle"
            title="nie możesz wybrać tej oferty"
          />
        </BlockContent>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
